import SelectItemIcon from '@ui/components/Select/components/SelectItemIcon';
import styles from '@ui/components/Select/Select.module.scss';
import React from 'react';

const SelectLabelMultiple = ({ selectedItem, placeholder, items }) => {
  const n = selectedItem?.length;

  return (
    <div className={styles.selectedItem}>
      <SelectItemIcon src="list" />
      <div className={styles.separator} role="presentation" />
      {!Number.isNaN(n) && n > 0 ? (
        <>
          <span>
            {items.find(item => item.value === selectedItem[0])?.label}
          </span>
          {n > 1 && (
            <span>
              (+{n - 1} weitere{n - 1 === 1 && 's'})
            </span>
          )}
        </>
      ) : (
        placeholder
      )}
    </div>
  );
};

export default SelectLabelMultiple;
